import { render } from "./field_submitter.vue?vue&type=template&id=bf5076c0"
import script from "./field_submitter.vue?vue&type=script&lang=js"
export * from "./field_submitter.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/gosign-staging/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__